import type { DisciplineGeneralInfoStore } from './interfaces'

export const getters = {
  getForm: (state: DisciplineGeneralInfoStore): DisciplineGeneralInfoStore['form'] => state.form,
  isSaving: (state: DisciplineGeneralInfoStore): DisciplineGeneralInfoStore['saving'] => state.saving,
  getActiveModal: (state: DisciplineGeneralInfoStore): DisciplineGeneralInfoStore['activeModal'] => state.activeModal,
  getMergeIds: (state: DisciplineGeneralInfoStore): DisciplineGeneralInfoStore['mergeIds'] => state.mergeIds,
}
